import View from 'mixins/view';
import ArticleNotificationView from 'ui/login-bar/mixins/notification-view';
import UserNotificationView from 'ui/login-bar/mixins/user-notification-view';
import controller from 'ui/login-bar/controller';
import moment from 'moment/moment';

const elements = {
  tooltip: '.notifications__number',
  notificationsList: '.notifications-list',
  showMore: '.notifications-more.show-more',
  showOlder: '.notifications-more.show-older',
  noNotificationTrigger: '.notification-none',
  loader: '.notifications-loader',
  dockTrigger: '.js-BubbleBox-Call',
  dockTriggerActivePointer: '.js-BubbleBox-Call.user-toolkit-action',
  active: '.user-toolkit__new-msgs',
};

export default class NotificationContainerView extends View {
  constructor(model) {
    super(model);
    this.setRootEl($(elements.container));
    this.collapsed = true;
  }
  initSizes($wrapper) {
    const bubble = $wrapper.find('.ui-BubbleBox');

    this.sizes = {
      position: bubble.data('ui-bubblebox-position'),
      shift: bubble.data('ui-bubblebox-shift'),
      width: bubble.data('ui-bubblebox-width'),
    }
  }
  applyResizeEvent($wrapper) {
    const offset = 10;
    const stores = this.sizes;

    const bubble = $wrapper.find('.ui-BubbleBox');
    const caller = $wrapper.find('.user-toolkit-action');

    if (document.body.clientWidth <= 800) {
      bubble.data('ui-bubblebox-position', 'left')
            .data('ui-bubblebox-shift', '-' + (caller.offset().left - offset))
            .data('ui-bubblebox-width', (document.body.clientWidth - (offset * 2)));

      bubble.css('right', 'initial')
            .css('left', '-' + (caller.offset().left - offset) + 'px')
            .css('width', (document.body.clientWidth - (offset * 2)) + 'px');
    } else {
      bubble.data('ui-bubblebox-position', stores.position)
            .data('ui-bubblebox-shift', stores.shift)
            .data('ui-bubblebox-width', stores.width);

      bubble.css('right', 'initial')
            .css('left', 'initial')
            .css(stores.position, stores.shift + 'px')
            .css('width', stores.width + 'px');
    }
  }
  focus() {
    this.rootEl.addClass('user-toolkit__new-msgs');
  }
  showLoadingBar() {
    this.rootEl.find(elements.showOlder).addClass('fn-hidden');
    this.rootEl.find(elements.showMore).addClass('fn-hidden');
    this.rootEl.find(elements.noNotificationTrigger).addClass('fn-hidden');
    this.rootEl.find(elements.notificationsList).addClass('fn-hidden');
    this.rootEl.find(elements.loader).removeClass('fn-hidden');
  }
  bulkDockTriggers() {
    return this.rootEl.find(elements.dockTrigger)
      .on('click', (event) => {
        setTimeout(() => {
          this.collapsed = this.rootEl.find(elements.dockTriggerActivePointer)
            .hasClass('fn-active');
          if (this.collapsed) {
            controller.stopCheckingStatus();
            this.updateTooltip();
          } else {
            controller.checkStatus();
          }
        }, 0);
      });
  }
  fillLastLogin() {
    const count = this.model.get('newSinceLastVisit');
    moment.locale('pl');
    const time = moment(this.model.get('lastVisitAt')).fromNow();
    this.rootEl.find('span.count').html(count);
    this.rootEl.find(`${elements.showMore} .time`).html(time);
    this.rootEl.find(`${elements.noNotificationTrigger} .time`)
      .html(time);
  }
  updateTooltip(count) {
    if (count) {
      this.rootEl.addClass(elements.active.substr(1));
      this.rootEl.find(elements.tooltip)
        .html(count)
        .removeClass('fn-hidden');
    } else {
      this.rootEl.removeClass(elements.active.substr(1));
      this.rootEl.find(elements.tooltip)
        .html('')
        .addClass('fn-hidden')
    }
  }
  addMessage(type, model) {
    const newNotification = (type === 'article') ? new ArticleNotificationView(model) : new UserNotificationView(model);
    newNotification.render();
    this.rootEl.find(elements.notificationsList)
      .append(newNotification.getRootEl());
  }
  render() {
    this.bulkDockTriggers();
  }
}



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/login-bar/mixins/container-view.js